import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Pipe({
    name: 'authentication',
})
export class AuthenticationPipe implements PipeTransform {

    constructor(private myAuthenticationService: AuthenticationService) {}

    public transform(roles: string | string[]): boolean {
        return this.myAuthenticationService.userHasRoles(roles);
    }

}
